module.exports = {
  HtmlContent: {
    PluginName: "HTML İçerik",
  },
};
